module.exports = "../../static/img/hat_christmas.b581a84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hat_christmas.png
// module id = 1357
// module chunks = 0